module.exports = __webpack_public_path__ + "static/img/login_bk.5de7869.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_bk.jpg
// module id = nRpH
// module chunks = 1